const SvgStarFilledBlue = (props) => {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 14 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M13.9634 5.36979C13.8712 5.08631 13.6198 4.88561 13.3235 4.8588L9.28209 4.49189L7.68491 0.752571C7.56698 0.477847 7.29867 0.300537 7.00002 0.300537C6.70137 0.300537 6.43295 0.477847 6.31577 0.752571L4.71859 4.49189L0.676564 4.8588C0.380264 4.88614 0.129359 5.08684 0.0366454 5.36979C-0.0555345 5.65327 0.0295957 5.96421 0.25369 6.16074L3.30866 8.83951L2.4079 12.8068C2.342 13.0985 2.45522 13.4001 2.69726 13.5751C2.82736 13.6696 2.98021 13.7168 3.13359 13.7168C3.2654 13.7168 3.39731 13.6818 3.51513 13.6113L7.00002 11.5276L10.4843 13.6113C10.7399 13.764 11.0613 13.75 11.3028 13.5751C11.5448 13.4001 11.658 13.0985 11.5921 12.8068L10.6914 8.83951L13.7463 6.16074C13.9703 5.96421 14.0556 5.65391 13.9634 5.36979Z"
				fill="#2368a2"
				{...props}
			/>
		</svg>
	);
};

export default SvgStarFilledBlue;
